export default __webpack_public_path__ + "static/media/client9.31adda64.jpeg";